import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Antes era `false`: uma falha transitória (ex: cookie de sessão ainda não anexado
      // logo após a navegação) deixava a query travada em erro pra sempre — só um remount
      // (sair e entrar de novo na página) tentava buscar de novo. 1 retry cobre esse caso.
      retry: 1,
      throwOnError: false,
      refetchOnWindowFocus: false,
    },
  },
});
